export enum ChartDesignerActionTypes {
    CHANGE_ISSORTING = '@@chartDesigner/CHANGE_ISSORTING',
    CHANGE_ISCONDITIONALLY = '@@chartDesigner/CHANGE_ISCONDITIONALLY',
    CHANGE_ISTOPN = '@@chartDesigner/CHANGE_ISTOPN',
    CHANGE_TOPNType = '@@chartDesigner/CHANGE_TOPNType',    
    CHANGE_ISALARM = '@@chartDesigner/CHANGE_ISALARM',
    CHANGE_isDrillTrogh = '@@chartDesigner/CHANGE_isDrillTrogh',
    CHANGE_DrillTroghItem = '@@chartDesigner/CHANGE_DrillTroghItem',

    CHANGE_ISCHANGESHAXES = '@@chartDesigner/CHANGE_ISCHANGESHAXES',
    CHANGE_SEARCH_VALUE = '@@chartDesigner/CHANGE_SEARCH_VALUE',
    CHANGE_CHARTID = '@@chartDesigner/CHANGE_CHARTID',
    CHANGE_FIELD = '@@chartDesigner/CHANGE_FIELD',
    CHANGE_BOAD = '@@chartDesigner/CHANGE_BOAD',
    CHANGE_SHAXES = '@@chartDesigner/CHANGE_SHAXES',
    CHANGE_CURRENTSHAXESID = '@@chartDesigner/CHANGE_CURRENTSHAXESID',
    CHANGE_CURRENTBOADID = '@@chartDesigner/CHANGE_CURRENTBOADID',
    CHANGE_NEWFIELD = '@@chartDesigner/CHANGE_NEWFIELD',
    CHANGE_ADDNEWFIELD = '@@chartDesigner/CHANGE_ADDNEWFIELD',
    CHANGE_DELETENEWFIELD = '@@chartDesigner/CHANGE_DELETENEWFIELD',
    CHANGE_CONDOTION = '@@chartDesigner/CHANGE_CONDOTION',
    CHANGE_GROUPES = '@@chartDesigner/CHANGE_GROUPES',
    CHANGE_CHARTTYPE = '@@chartDesigner/CHANGE_CHARTTYPE',
    CHANGE_CHARTCOLORPALLET = '@@chartDesigner/CHANGE_CHARTCOLORPALLET',
    CHANGE_CHART_DATA = '@@chartDesigner/CHART_DATA',
    CHANGE_DRILLVALUE = '@@chartDesigner/CHANGE_DRILLVALUE',
    CHANGE_CHART_DRILL = '@@chartDesigner/CHART_DRILL',
    CHANGE_CHART_DRILL_STEP = '@@chartDesigner/CHART_DRILL_STEP',
    CHANGE_SHAXES_AGGREGATION = '@@chartDesigner/CHART_SHAXES_AGGREGATION',
    CHANGE_SHAXES_ISNOTNULLAGREGATION = '@@chartDesigner/CHART_SHAXES_ISNOTNULLAGREGATION',
    CHANGE_SHAXES_NONEVALUETYPEAGREGATION = '@@chartDesigner/CHANGE_SHAXES_NONEVALUETYPEAGREGATION',
    CHANGE_SHAXES_UNIQNAME = '@@chartDesigner/CHANGE_SHAXES_UNIQNAME',
    CHANGE_BOAD_UNIQNAME = '@@chartDesigner/CHANGE_BOAD_UNIQNAME',
    CHANGE_SHAXES_CALCULATETYPE = '@@chartDesigner/CHART_SHAXES_CALCULATETYPE',
    CHANGE_SHAXES_CHARTTYPE = '@@chartDesigner/CHANGE_SHAXES_CHARTTYPE',

    CHANGE_SHAXES_HEATMAPMODE = '@@chartDesigner/CHART_SHAXES_HEATMAPMODE',
    CHANGE_SHAXES_HEATMAPCOLOR = '@@chartDesigner/CHANGE_SHAXES_HEATMAPCOLOR',
    CHANGE_SHAXES_HEATMAPCOLOR2 = '@@chartDesigner/CHANGE_SHAXES_HEATMAPCOLOR2',

    CHANGE_SHAXES_ISSHOWTOTAL = '@@chartDesigner/CHANGE_SHAXES_ISSHOWTOTAL',
    CHANGE_SHAXES_DESIGN = '@@chartDesigner/CHART_SHAXES_DESIGN',
    CHANGE_BOAD_FILTER = '@@chartDesigner/CHANGE_BOAD_FILTER',
    CHANGE_BOAD_SORT = '@@chartDesigner/CHANGE_BOAD_SORT',
    CHANGE_SHAXES_SORT = '@@chartDesigner/CHANGE_SHAXES_SORT',
    CHANGE_SHAXES_CONDITIONALLITY = '@@chartDesigner/CHANGE_SHAXES_CONDITIONALLITY',
    CHANGE_ALARM = '@@chartDesigner/CHANGE_ALARM',
    CHANGE_TopN = '@@chartDesigner/CHANGE_TopN',
    CHANGE_TABLE_CONDITIONALLITY = '@@chartDesigner/CHANGE_TABLE_CONDITIONALLITY',

    CHANGE_SHAXES_FILTER = '@@chartDesigner/CHANGE_SHAXES_FILTER',
    CHANGE_CONDITION_FILTER = '@@chartDesigner/CHANGE_CONDITION_FILTER',

    CHANGE_BOAD_FILTERCRITERIA = '@@chartDesigner/CHANGE_BOAD_FILTERCRITERIA',
    CHANGE_SHAXES_FILTERCRITERIA = '@@chartDesigner/CHANGE_SHAXES_FILTERCRITERIA',
    CHANGE_CONDITION_FILTERCRITERIA = '@@chartDesigner/CHANGE_CONDITION_FILTERCRITERIA',

    CHANGE_SHAXES_FILTERAGGREGATION = '@@chartDesigner/CHANGE_SHAXES_FILTERAGGREGATION',

    CHANGE_BOAD_FILTERGVARIABLE = '@@chartDesigner/CHANGE_BOAD_FILTERGVARIABLE',
    CHANGE_CONDITION_FILTERGVARIABLE = '@@chartDesigner/CHANGE_CONDITION_FILTERGVARIABLE',


    CHANGE_RESET_INITIAL_STATE = '@@chartDesigner/RESET_INITIAL_STATE',

    CHANGE_MAPTYPE = '@@chartDesigner/MAPTYPE',
    CHANGE_GAUGETYPE = '@@chartDesigner/GAUGETYPE',



    CHANGE_TESTAM = '@@chartDesigner/CHANGE_TESTAM',

    CHANGE_ACTIVEKEY_PUBLICSETTINGS = '@@chartDesigner/ACTIVEKEY_PUBLICSETTINGS',

    CHANGE_CHART_PUBLIC = '@@chartDesigner/CHANGE_CHART_PUBLIC',
    CHANGE_CHART_LEGEND = '@@chartDesigner/CHART_LEGEND',

    CHANGE_CHART_LABELONCHART = '@@chartDesigner/CHART_LABELONCHART',
    CHANGE_CHART_TABLESTYLE = '@@chartDesigner/CHART_TABLESTYLE',
    CHANGE_CHART_TOOLTIP = '@@chartDesigner/CHART_TOOLTIP',
    CHANGE_CHART_WIDGET = '@@chartDesigner/CHANGE_CHART_WIDGET',
    CHANGE_CHART_TEXT = '@@chartDesigner/CHANGE_CHART_TEXT',
    CHANGE_CHART_FUNNEL = '@@chartDesigner/CHART_FUNNEL',
    CHANGE_CHART_LINE = '@@chartDesigner/CHART_LINE',
    CHANGE_CHART_RANGEMARKER = '@@chartDesigner/CHANGE_CHART_RANGEMARKER',

    CHANGE_CHART_LINEAREA = '@@chartDesigner/CHART_LINEAREA',

    CHANGE_CHART_GAUGE = '@@chartDesigner/CHART_GAUGE',
    CHANGE_CHART_MAP = '@@chartDesigner/CHART_MAP',
    CHANGE_CHART_PIE = '@@chartDesigner/CHART_PIE',
    CHANGE_CHART_PICS = '@@chartDesigner/CHART_PICS',
    CHANGE_CHART_SCATTER = '@@chartDesigner/CHART_SCATTER',

    CHANGE_CHART_GRIDLINE = '@@chartDesigner/CHART_GRIDLINE',
    CHANGE_GET_CONDITIONALLITYLIST = '@@chartDesigner/GET_CONDITIONALLITYLIST',
    CHANGE_CONDITIONALLITY = '@@chartDesigner/CHANGE_CONDITIONALLITY',

}
